import { VideoPlayer, VideoPlayerProps } from 'components/media'
import { useEffect, useState } from 'react'
import { useExplorerConfig } from '../providers'

export interface Props extends Omit<VideoPlayerProps, 'source' | 'playing'> {
  mediaId: string
  paused?: boolean
}

export default function MediaVideo({
  mediaId,
  paused: parentPaused,
  height = '100%',
  width = '100%',
  ...rest
}: Props) {
  const { templateDocs } = useExplorerConfig()
  const [paused, setPaused] = useState(parentPaused)

  useEffect(() => {
    setPaused(parentPaused)
  }, [parentPaused])

  const media = templateDocs?.media.find(m => m.id === mediaId)
  if (!media) return null

  const aspectRatio = media.dimensions.width / media.dimensions.height
  let _height = height
  let _width = width
  if (typeof height === 'number') _width = height * aspectRatio
  if (typeof width === 'number') _height = width / aspectRatio

  return (
    <VideoPlayer
      src={media.url}
      cover={paused ? media.coverUrl : undefined}
      playing={!paused}
      height={_height}
      width={_width}
      {...rest}
    />
  )
}
